import { compareVersion } from 'common/js/common'
const RELATION_TEXT_MAP = {
  2: '配偶',
  18: '父亲',
  19: '母亲',
  12: '子女',
  16: '儿子',
  17: '女儿',
  20: '其他'
}

export function getRelation(value, sex) {
  if (value === null) return '本人'
  if (value == 12 && sex) return RELATION_TEXT_MAP[sex == 1 ? 16 : 17]
  return RELATION_TEXT_MAP[value] || '其他'
}

export function baoeShowWords({
  calMethod,
  baoe,
  baoeDesc,
  showPlanDesc,
  planDesc,
  plan
}) {
  // 复制自 src/components/person/personV2.vue
  // showPlanDesc === 'undefined'，会有这种场景？？
  let baoeDp = baoeDesc || baoe || '-'
  if (!calMethod) {
    if (showPlanDesc) {
      baoeDp = planDesc
    } else if (showPlanDesc === 'undefined') {
      // planDesc 存在且不等于 plan 显示
      if (planDesc && planDesc != plan) {
        baoeDp = planDesc
      }
    }
  }
  return baoeDp
}

export function showImageViewer(dataURL) {
  const ver =
    window.appBridge &&
    appBridge.getVerStr().match(/\d+\.\d+\.\d+/) &&
    appBridge.getVerStr().match(/\d+\.\d+\.\d+/)[0]
  if (ver && compareVersion(ver, '5.6.0') === '=') return
  window.WeiyiStatSDK.submit('SLT')
  if (
    !window.appBridge ||
    !appBridge.checkAppFeature('NATIVE_IMAGE_VIEWER') ||
    !dataURL
  ) {
    return
  }
  appBridge
    .showImageViewer({
      urls: [dataURL]
    })
    .catch(function (e) {
      console.log('toast', e.name + '  ' + e.message)
    })
}